import React from 'react'

import LogRocket from 'logrocket'
import { ConfirmProvider } from 'material-ui-confirm'
import { hydrate, render } from 'react-dom'
import Provider from 'react-redux/es/components/Provider'

import store from '@kolayyolla/common/store'

import AuthRouter from './AuthRouter'
import ServiceWorkerWrapper from './ServiceWorkerWrapper'
import ThemeEngine from './ThemeEngine'

import './index.css'
const rootElement = document.getElementById('root')

LogRocket.init('rtkqqe/kolayyolla')

if (rootElement.hasChildNodes()) {
  hydrate(
    <Provider store={store}>
      <ConfirmProvider>
        <ServiceWorkerWrapper />
        <ThemeEngine>
          <AuthRouter />
        </ThemeEngine>
      </ConfirmProvider>
    </Provider>, rootElement
  )
} else {
  render(
    <Provider store={store}>
      <ConfirmProvider>
        <ServiceWorkerWrapper />
        <ThemeEngine>
          <AuthRouter />
        </ThemeEngine>
      </ConfirmProvider>
    </Provider>, rootElement
  )
}
